import React from 'react';
import classNames from 'classnames';
import styles from './hotelCardLocation.module.css';

type HotelCardLocationProps = {
  children: string;
  isMobile: boolean;
};

const HotelCardLocation: React.FC<HotelCardLocationProps> = ({
  children,
  isMobile,
}) => (
  <p
    className={classNames({
      [styles.locationMobile]: isMobile,
      [styles.locationDesktop]: !isMobile,
    })}
  >
    {children}
  </p>
);

export default HotelCardLocation;
